import script from "./MattersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MattersTable.vue?vue&type=script&setup=true&lang=ts"

import "./MattersTable.vue?vue&type=style&index=0&id=fe587bf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe587bf4"]])

export default __exports__